import { MChapterData } from './chapter-data.model';
import { MRequirementEvaluation } from './requirement-evaluation.model';
import { RequirementEvaluation, ChapterData } from '../interfaces/Organization';

export class MRequirement{
    public data: MChapterData = null;
    public evaluation: MRequirementEvaluation = null;
    public lastEvaluation: MRequirementEvaluation = null;

    constructor(data:ChapterData){
        this.data = new MChapterData(data);
        if (data.evaluacion) {
            this.evaluation = new MRequirementEvaluation(data.evaluacion);
        }
        if (data.ultima_evaluacion_requisito) {
            this.lastEvaluation = new MRequirementEvaluation(data.ultima_evaluacion_requisito)
        }
    }
}